// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import leaveService from '../../services/LeaveService';

// export const fetchLeaveTypes = createAsyncThunk(
//   'leaveTypes/fetchAll',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await leaveService.GetLeaveTypeList();
      
//       console.log("[fetchLeaveTypes] Response:", response);

//       if (response?.StatusCode !== 200) {
//         throw new Error(response?.Message || "Failed to retrieve leave types.");
//       }

//       const leaveTypes = response?.ResultSet || [];
      
//       const formattedTypes = leaveTypes.map((item) => ({
//         id: item.HLT_TYPE_ID,
//         code: item.HLT_CODE,
//         name: item.HLT_NAME,
//         paid: item.HLT_IS_PAID,
//         status: item.HLT_ACTIVE_STATUS,
//         displayOrder: item.HLT_DISPLAY_ORDER,
//         raw: item
//       }));

//       return formattedTypes;
//     } catch (error) {
//       console.error("[fetchLeaveTypes] Error:", error);
//       return rejectWithValue(error.message || "Failed to load leave types.");
//     }
//   }
// );

// export const createLeaveType = createAsyncThunk(
//   'leaveTypes/create',
//   async (payload, { rejectWithValue }) => {
//     try {
//       const response = await leaveService.PostLeaveType(payload);
      
//       console.log("[createLeaveType] Response:", response);

//       if (response?.StatusCode !== 200) {
//         throw new Error(response?.Message || "Failed to create leave type.");
//       }

//       return response;
//     } catch (error) {
//       console.error("[createLeaveType] Error:", error);
//       return rejectWithValue(error.message || "Failed to create leave type.");
//     }
//   }
// );

// export const updateLeaveType = createAsyncThunk(
//   'leaveTypes/update',
//   async ({ typeId, ...payload }, { rejectWithValue }) => {
//     try {
//       // Add typeId to payload for update
//       const updatePayload = {
//         ...payload,
//         typeId: typeId
//       };
      
//       const response = await leaveService.PostLeaveType(updatePayload);
      
//       console.log("[updateLeaveType] Response:", response);

//       if (response?.StatusCode !== 200) {
//         throw new Error(response?.Message || "Failed to update leave type.");
//       }

//       return response;
//     } catch (error) {
//       console.error("[updateLeaveType] Error:", error);
//       return rejectWithValue(error.message || "Failed to update leave type.");
//     }
//   }
// );

// // Initial state
// const initialState = {
//   types: [],
//   loading: false,
//   error: null,
//   saving: false,
//   saveError: null,
//   search: '',
// };

// // Slice
// const leaveTypesSlice = createSlice({
//   name: 'leaveTypes',
//   initialState,
//   reducers: {
//     setSearch: (state, action) => {
//       state.search = action.payload;
//     },
//     clearError: (state) => {
//       state.error = null;
//       state.saveError = null;
//     },
//     resetState: () => initialState,
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch
//       .addCase(fetchLeaveTypes.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLeaveTypes.fulfilled, (state, action) => {
//         state.loading = false;
//         state.types = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchLeaveTypes.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || "Failed to load leave types.";
//         state.types = [];
//       })
      
//       // Create
//       .addCase(createLeaveType.pending, (state) => {
//         state.saving = true;
//         state.saveError = null;
//       })
//       .addCase(createLeaveType.fulfilled, (state) => {
//         state.saving = false;
//         state.saveError = null;
//       })
//       .addCase(createLeaveType.rejected, (state, action) => {
//         state.saving = false;
//         state.saveError = action.payload || "Failed to create leave type.";
//       })
      
//       // Update
//       .addCase(updateLeaveType.pending, (state) => {
//         state.saving = true;
//         state.saveError = null;
//       })
//       .addCase(updateLeaveType.fulfilled, (state) => {
//         state.saving = false;
//         state.saveError = null;
//       })
//       .addCase(updateLeaveType.rejected, (state, action) => {
//         state.saving = false;
//         state.saveError = action.payload || "Failed to update leave type.";
//       });
//   },
// });

// // Export actions
// export const { setSearch, clearError, resetState } = leaveTypesSlice.actions;

// // Selectors
// export const selectLeaveTypes = (state) => state.leaveTypes.types;
// export const selectLeaveTypesLoading = (state) => state.leaveTypes.loading;
// export const selectLeaveTypesError = (state) => state.leaveTypes.error;
// export const selectLeaveTypesSaving = (state) => state.leaveTypes.saving;
// export const selectLeaveTypesSaveError = (state) => state.leaveTypes.saveError;
// export const selectLeaveTypesSearch = (state) => state.leaveTypes.search;

// export default leaveTypesSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import leaveService from '../../services/LeaveService';
import { FetchLeaveTypeByUser } from '../../services/leaveTypeService';

// ── Pull the error message out of ANY response shape ───────────────
const extractMessage = (obj) => {
  if (!obj) return null;
  return (
    obj.Message ||
    obj.message ||
    obj.errorMessage ||
    obj.ErrorMessage ||
    obj.Result ||         
    obj.result ||
    obj.data?.Message ||
    obj.data?.message ||
    obj.data?.errorMessage ||
    obj.data?.Result ||
    obj.data?.result ||
    null
  );
};

const isDuplicateKeyError = (msg) =>
  /duplicate key|UNIQUE KEY constraint/i.test(String(msg || ''));

// ── Turn the raw SQL error into a friendly sentence ────────────────
const translateDbError = (raw) => {
  if (!raw) return null;
  const str = String(raw);

  if (isDuplicateKeyError(str)) {
    // e.g. "... The duplicate key value is (TS1)."
    const m = str.match(/duplicate key value is \(([^)]+)\)/i);
    return m
      ? `Code "${m[1]}" already exists. Please choose a different code.`
      : 'This code already exists. Please choose a different code.';
  }

  return str;
};

const getErrorMessage = (error) =>
  (error?.response &&
    error.response.data &&
    (error.response.data.Message ||
      error.response.data.message ||
      error.response.data.Result)) ||
  error?.message ||
  String(error);

// ── fetchLeaveTypesByUser (unchanged) ──────────────────────────────
export const fetchLeaveTypesByUser = createAsyncThunk(
  'leaveTypes/fetchByUser',
  async (serviceNo) => {
    if (!serviceNo) {
      return { success: false, message: 'Service number is required', data: null };
    }
    try {
      const response = await FetchLeaveTypeByUser(serviceNo);
      if (response && response.data) {
        return {
          success: true,
          data: response.data,
          message: response.data?.Message || 'Leave types fetched successfully',
        };
      }
      return {
        success: true,
        data: response,
        message: 'Leave types fetched successfully',
      };
    } catch (error) {
      const message = getErrorMessage(error);
      console.error('[fetchLeaveTypesByUser] Error:', message);
      return { success: false, message, error, data: null };
    }
  }
);

// ── fetchLeaveTypes (also normalised paid/status) ──────────────────
export const fetchLeaveTypes = createAsyncThunk(
  'leaveTypes/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await leaveService.GetLeaveTypeList();
      console.log('[fetchLeaveTypes] Response:', response);

      if (response?.StatusCode !== 200) {
        throw new Error(
          extractMessage(response) || 'Failed to retrieve leave types.'
        );
      }

      const leaveTypes = response?.ResultSet || [];

      const formattedTypes = leaveTypes.map((item) => ({
        id: item.HLT_TYPE_ID,
        code: item.HLT_CODE,
        name: item.HLT_NAME,
        paid: item.HLT_IS_PAID === 'Y' ? 'Yes' : 'No',
        status: item.HLT_ACTIVE_STATUS === 'A' ? 'Active' : 'Inactive',
        displayOrder: item.HLT_DISPLAY_ORDER,
        raw: item,
      }));

      return formattedTypes;
    } catch (error) {
      console.error('[fetchLeaveTypes] Error:', error);
      return rejectWithValue(
        getErrorMessage(error) || 'Failed to load leave types.'
      );
    }
  }
);

// ── createLeaveType ────────────────────────────────────────────────
export const createLeaveType = createAsyncThunk(
  'leaveTypes/create',
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await leaveService.PostLeaveType(payload);
      console.log('[createLeaveType] Response:', response);

      // Case A: 200 HTTP but StatusCode 
      const statusCode = response?.StatusCode ?? response?.data?.StatusCode;
      if (statusCode !== 200) {
        const raw = extractMessage(response);
        if (isDuplicateKeyError(raw)) {
          dispatch(fetchLeaveTypes());
        }
        return rejectWithValue(
          translateDbError(raw) || 'Failed to create leave type.'
        );
      }

      return response;
    } catch (error) {
      console.error('[createLeaveType] Error:', error);

      // Case B: axios threw 
      const raw =
        extractMessage(error?.response?.data) ||
        extractMessage(error) ||
        error?.message;

      if (isDuplicateKeyError(raw)) {
        dispatch(fetchLeaveTypes());
      }

      return rejectWithValue(
        translateDbError(raw) || 'Failed to create leave type.'
      );
    }
  }
);

// ── updateLeaveType ────────────────────────────────────────────────
export const updateLeaveType = createAsyncThunk(
  'leaveTypes/update',
  async ({ typeId, ...payload }, { rejectWithValue, dispatch }) => {
    try {
      const updatePayload = { ...payload, typeId };
      const response = await leaveService.PostLeaveType(updatePayload);
      console.log('[updateLeaveType] Response:', response);

      const statusCode = response?.StatusCode ?? response?.data?.StatusCode;
      if (statusCode !== 200) {
        const raw = extractMessage(response);
        if (isDuplicateKeyError(raw)) dispatch(fetchLeaveTypes());
        return rejectWithValue(
          translateDbError(raw) || 'Failed to update leave type.'
        );
      }

      return response;
    } catch (error) {
      console.error('[updateLeaveType] Error:', error);

      const raw =
        extractMessage(error?.response?.data) ||
        extractMessage(error) ||
        error?.message;

      if (isDuplicateKeyError(raw)) dispatch(fetchLeaveTypes());

      return rejectWithValue(
        translateDbError(raw) || 'Failed to update leave type.'
      );
    }
  }
);

// ── Slice (unchanged apart from the items above) ───────────────────
const initialState = {
  types: [],
  loading: false,
  error: null,
  saving: false,
  saveError: null,
  search: '',
};

const leaveTypesSlice = createSlice({
  name: 'leaveTypes',
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    clearError: (state) => {
      state.error = null;
      state.saveError = null;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchLeaveTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaveTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.types = action.payload;
        state.error = null;
      })
      .addCase(fetchLeaveTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load leave types.';
        state.types = [];
      })

      // Create
      .addCase(createLeaveType.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(createLeaveType.fulfilled, (state) => {
        state.saving = false;
        state.saveError = null;
      })
      .addCase(createLeaveType.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload || 'Failed to create leave type.';
      })

      // Update
      .addCase(updateLeaveType.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(updateLeaveType.fulfilled, (state) => {
        state.saving = false;
        state.saveError = null;
      })
      .addCase(updateLeaveType.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload || 'Failed to update leave type.';
      });
  },
});

export const { setSearch, clearError, resetState } = leaveTypesSlice.actions;

export const selectLeaveTypes = (state) => state.leaveTypes.types;
export const selectLeaveTypesLoading = (state) => state.leaveTypes.loading;
export const selectLeaveTypesError = (state) => state.leaveTypes.error;
export const selectLeaveTypesSaving = (state) => state.leaveTypes.saving;
export const selectLeaveTypesSaveError = (state) => state.leaveTypes.saveError;
export const selectLeaveTypesSearch = (state) => state.leaveTypes.search;

export default leaveTypesSlice.reducer;